import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IDateType } from '../Types';

export interface IAspectsAndTopicsProps {
  id: string;
  is_active: boolean;
  legend: string;
  max_send_qtd: number;
  max_value: number;
  name: string;
  orientation: string;
  position: number;
  registration_id: string;
  titles_topics: ITitleTopics[];
  total_aspect_send: number;
  total_points_declared: number;
  max_value_ilimited: boolean;
  max_send_qtd_ilimited: boolean;
}

export interface ITitleTopics {
  aspect: string;
  created_at: IDateType;
  id: string;
  is_active: boolean;
  legend: string;
  maximum_score: number;
  name: string;
  position: number;
  qtd_max_title: number;
  qtd_unity_to_score: number;
  total_send: number;
  type: string;
  unity: string;
  unity_points: number;
  updated_at: string;
  titles_send: ITitlesProps[];
  max_score_ilimited: boolean;
  qtd_max_title_ilimited: boolean;
}

interface IAttachProps {
  created_at: string;
  id: string;
  name: string;
  sent_by_client: boolean;
  status: string;
  url: string;
}

export interface ITitlesProps {
  attachements: IAttachProps[];
  declared_value: number;
  id: string;
  justification: string;
  observation: string;
  result: string;
  score: string;
  status: { id: string; name: string };
  total_points_declared_per_title: number;
  protocol_code: number;
  created_at: IDateType;
}

interface IParams {
  registrationId?: string;
  remove_pagination?: boolean;
  step_id?: string;
}

const GetTitlesTopicsData = async <T>(params?: IParams) => {
  const response = await configApi.get<T>(`candidate-area/titles-candidate/`, {
    params: {
      remove_pagination: params?.remove_pagination,
      registration_id: params?.registrationId,
      step: params?.step_id,
    },
  });
  return response.data;
};

export const useGetTitlesTopicsData = <T>(params?: IParams) => {
  return useQuery({
    queryKey: ['get_titles_topic_data', params],
    queryFn: () => GetTitlesTopicsData<T>(params),
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};
